import { render } from "./StyleguideTableOptionsMassActions.pug?vue&type=template&id=33b51c76&lang=pug"
import script from "./StyleguideTableOptionsMassActions.js?vue&type=script&lang=js"
export * from "./StyleguideTableOptionsMassActions.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__